import blog1 from '../assets/images/blog/1.jpg'
import blog2 from '../assets/images/blog/2.jpg'
import blog3 from '../assets/images/blog/3.jpg'
import blog4 from '../assets/images/blog/4.jpg'
import blog5 from '../assets/images/blog/5.jpg'
import blog6 from '../assets/images/blog/6.jpg'
import blog7 from '../assets/images/blog/7.jpg'
import blog8 from '../assets/images/blog/8.jpg'
import blog9 from '../assets/images/blog/9.jpg'
import team1 from '../assets/images/team/01.jpg'
import team2 from '../assets/images/team/02.jpg'
import team3 from '../assets/images/team/03.jpg'
import team4 from '../assets/images/team/04.jpg'
import team5 from '../assets/images/team/05.jpg'
import team6 from '../assets/images/team/06.jpg'
import team7 from '../assets/images/team/07.jpg'
import team8 from '../assets/images/team/08.jpg'

export const blogData = [
    {
        id:1,
        image:blog1,
        title:'Design your apps in your own way',
        athor:'Thomas Israel',
        image1:team1,
        date:"13th September 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:2,
        image:blog2,
        title:'How apps is changing the IT world',
        athor:'Barbara McIntosh',
        image1:team2,
        date:"29th November 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:3,
        image:blog3,
        title:'Smartest Applications for Business',
        athor:'Carl Oliver',
        image1:team3,
        date:"13th March 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:4,
        image:blog4,
        title:'Mobile Marketing, Its Synthes and 2021 Offer Prognosis',
        athor:'Jill Webb',
        image1:team4,
        date:"6th May 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:5,
        image:blog5,
        title:'Stop Worrying About Deadlines! We Got You Covered',
        athor:'Thomas Israel',
        image1:team5,
        date:"19th June 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:6,
        image:blog6,
        title:'Change Your Strategy: Find a Business Consultant',
        athor:'Janisha Doll',
        image1:team6,
        date:"20th June 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:7,
        image:blog7,
        title:'Everything About Financial Modeling',
        athor:'Jill Webb',
        image1:team7,
        date:"31st August 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:8,
        image:blog8,
        title:'On the other hand we provide denounce',
        athor:'Carl Oliver',
        image1:team8,
        date:"1 September 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
    {
        id:9,
        image:blog9,
        title:'Design your apps in your own way',
        athor:'Thomas Israel',
        image1:team1,
        date:"31 December 2023",
        desc:"The phrasal sequence of the is now so that many campaign and benefit"
    },
]